// src/components/StatsDashboard.jsx
import { useEffect, useState } from "react";
import { db, collection, onSnapshot, query } from "./firebase"; // Ajusta la ruta
// (Tus imports de charts pueden quedarse si los usás en otra parte)
// import { Bar, Line } from "react-chartjs-2";
import {
    getStartOfDay,
    getStartOfMonth,
    // getLast7Dates,
    // getLast6Months
} from "./utils/dateHelpers";
import { useChatSource } from "./context/ChatSourceContext"; // 👈 NUEVO

// Si usás charts, mantené estos registros
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend } from "chart.js";
// ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

/* Normaliza Firestore Timestamp o número a ms */
function toMillis(ts) {
    if (typeof ts === "number") return ts;
    if (ts?.toMillis) return ts.toMillis();
    if (ts?.seconds) return ts.seconds * 1000;
    return 0;
}

export default function StatsDashboard() {
    const { currentCollection } = useChatSource(); // 👈 colección dinámica desde el Dashboard

    // Indicadores
    const [dailyConversations, setDailyConversations] = useState(0);
    const [dailyNewUsers, setDailyNewUsers] = useState(0);
    const [monthlyConversations, setMonthlyConversations] = useState(0);
    const [monthlyNewUsers, setMonthlyNewUsers] = useState(0);

    // Si más adelante querés usarlos en gráficas
    // const [dailyConvosChartData, setDailyConvosChartData] = useState(null);
    // const [monthlyConvosChartData, setMonthlyConvosChartData] = useState(null);

    // (Opcional) colecciones auxiliares globales
    const [frequentQueriesData, setFrequentQueriesData] = useState([]);
    const [untrainedQueriesData, setUntrainedQueriesData] = useState([]);

    // 🔄 Suscripción a la colección dinámica de “active users”
    useEffect(() => {
        const qActiveUsers = query(collection(db, currentCollection));
        const unsubscribe = onSnapshot(qActiveUsers, (snapshot) => {
            const rows = snapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    __createdAtMs: toMillis(data.createdAt),
                    __lastUpdateMs: toMillis(data.lastUpdate),
                };
            });
            processConversationsData(rows);
            processUsersData(rows);
            // processConversationsDataCharts(rows);
        });

        return () => unsubscribe();
    }, [currentCollection]);

    // 🔄 Suscripción a “frequentQueries” (global, no cambia con perfil)
    useEffect(() => {
        const qFrequent = query(collection(db, "frequentQueries"));
        const unsub = onSnapshot(qFrequent, (snapshot) => {
            setFrequentQueriesData(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);

    // 🔄 Suscripción a “untrainedQueries” (global, no cambia con perfil)
    useEffect(() => {
        const qUntrained = query(collection(db, "untrainedQueries"));
        const unsub = onSnapshot(qUntrained, (snapshot) => {
            setUntrainedQueriesData(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);

    function processConversationsData(activeUsersDocs) {
        const startOfToday = getStartOfDay();   // ms
        const startOfMonth = getStartOfMonth(); // ms

        const updatedToday = activeUsersDocs.filter((d) => d.__lastUpdateMs >= startOfToday).length;
        const updatedMonth = activeUsersDocs.filter((d) => d.__lastUpdateMs >= startOfMonth).length;

        setDailyConversations(updatedToday);
        setMonthlyConversations(updatedMonth);
    }

    function processUsersData(activeUsersDocs) {
        const startOfToday = getStartOfDay();
        const startOfMonth = getStartOfMonth();

        const createdToday = activeUsersDocs.filter((d) => d.__createdAtMs >= startOfToday).length;
        const createdMonth = activeUsersDocs.filter((d) => d.__createdAtMs >= startOfMonth).length;

        setDailyNewUsers(createdToday);
        setMonthlyNewUsers(createdMonth);
    }

    return (
        <div className="space-y-6">
            {/* Tarjetas de indicadores */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                <IndicatorCard title="Conversaciones hoy" value={dailyConversations} />
                <IndicatorCard title="Nuevos usuarios hoy" value={dailyNewUsers} />
                <IndicatorCard title="Conversaciones mes" value={monthlyConversations} />
                <IndicatorCard title="Nuevos usuarios mes" value={monthlyNewUsers} />
            </div>
        </div>
    );
}

function IndicatorCard({ title, value }) {
    return (
        <div className="stats shadow bg-base-100">
            <div className="stat">
                <div className="stat-title">{title}</div>
                <div className="stat-value">{value}</div>
            </div>
        </div>
    );
}
